var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgELocalLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 512,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(.75 0 0 1 16 32)",
    id: "prefix__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0277bd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(0 32)",
    gradientUnits: "userSpaceOnUse",
    y2: 908.362,
    x2: 448,
    y1: 908.362,
    x1: 64,
    id: "prefix__e",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(32)",
    gradientUnits: "userSpaceOnUse",
    y2: -112,
    x2: 956.362,
    y1: -112,
    x1: 572.362,
    id: "prefix__d",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "translate(0 32)",
    gradientUnits: "userSpaceOnUse",
    y2: 620.362,
    x2: 448,
    y1: 620.362,
    x1: 64,
    id: "prefix__c",
    xlinkHref: "#prefix__b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__c)",
    d: "M64 604.362h384v96H64z",
    transform: "translate(0 -540.362)"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(90 270.181 -270.181)",
    fill: "url(#prefix__d)",
    d: "M604.362-160h384v96h-384z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__e)",
    d: "M64 892.362h384v96H64z",
    transform: "translate(0 -540.362)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    d: "M64 748.362h288v96H64z",
    transform: "translate(0 -540.362)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgELocalLogo);
export default __webpack_public_path__ + "static/media/eLocalLogo.6cb69b76eafaaca7671bfacc9416664a.svg";
export { ForwardRef as ReactComponent };